export default __webpack_public_path__ + "bc3946dfa7d0d47e0bf71f443d4ab5cf.png";